

module.exports = __webpack_require__.stylable.create(
    "ProfileMoreInfo2226283899",
    {"classes":{"root":"ProfileMoreInfo2226283899__root","ProfileName":"ProfileMoreInfo2226283899__ProfileName","UserIntro":"ProfileMoreInfo2226283899__UserIntro","WebsiteBtn":"ProfileMoreInfo2226283899__WebsiteBtn","SeeMoreBtn":"ProfileMoreInfo2226283899__SeeMoreBtn"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size:'16px' }\"","BioFont":"\"fallback(font(--bioFont), font({theme: 'Body-M', size:'16px' }))\"","HeaderBioColor":"\"fallback(color(--headerBioColor), color(color-4))\"","HeaderFullNameColor":"\"fallback(color(--headerFullNameColor), color(color-5))\"","HeaderLinksColor":"\"fallback(color(--headerLinksColor), color(color-8))\"","MobileBioFontSize":"'\"unit(fallback(--m_bioTextSize, 14), px)\"'"},"keyframes":{}},
    "",
    14,
    "ProfileMoreInfo2226283899",
    null
);
